import { handleResponse } from "utils/axios";
import { axiosInstance } from "./index";
import { onGetAllRegister } from "mocksdata/register";

/*Change Get Api here*/
const getAllRegisterEmail = async (query) => {
  onGetAllRegister();
  if (query.status === "") {
    delete query.status;
  }
  return axiosInstance({
    method: "get",
    url: "/merchants/registration",
    params: query,
  }).then(handleResponse);
};

/*Change Post Api here*/
const emailActions = async (data) => {
  return await axiosInstance.post("/merchants/registration", data).then(handleResponse);
};

/*Change Put Api here*/
const createEmail = async (data) => {
  return await axiosInstance.post("/whitelist-merchant", data).then(handleResponse);
};

/*Change Get Api here*/
// const deleteApi = async (id, data) => {
//   return await axiosInstance.delete("/merchants/registration", data).then(handleResponse);
// };

export { getAllRegisterEmail, emailActions, createEmail };
